import { render, staticRenderFns } from "./ShowUpdateComment.vue?vue&type=template&id=b059be78&lang=pug&"
import script from "./ShowUpdateComment.vue?vue&type=script&lang=js&"
export * from "./ShowUpdateComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports